import axios from "axios";
const BASE_URL = process.env.REACT_APP_BASE_URL + "/delivery-slots";

// Sets token in header
const setTokenAllHeaders = async () => {
    const token = localStorage.getItem("adminToken");
    axios.defaults.headers.common["Authorization"] = token;
};

// Fetch delivery slots with filters, sorting, pagination
const getDeliverySlots = async ({ limit = 10, page = 0, sortModel = [], filterModel = {}, branchId = null }) => {
    try {
        await setTokenAllHeaders();

        let search = null;
        if (filterModel?.quickFilterValues?.length > 0) {
            search = filterModel.quickFilterValues[0];
        }

        const sort = sortModel.map(({ field, sort }) => ({ field, sort }));

        const response = await axios.get(BASE_URL, {
            params: {
                limit,
                page,
                branchId,
                sort: JSON.stringify(sort),
                search
            }
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching delivery slots:", error);
        throw error;
    }
};

// Add or update delivery slots (single/bulk/all-branch)
const addOrUpdateDeliverySlots = async (data) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.post(`${BASE_URL}`, data);
        return response.data;
    } catch (error) {
        console.error("Error adding/updating delivery slots:", error);
        throw error;
    }
};

// Update status (activate/inactivate)
const updateSlotStatus = async ({ slotId, status }) => {
    try {
        await setTokenAllHeaders();
        const response = await axios.post(`${BASE_URL}/status`, {
            slotId,
            status
        });
        return response.data;
    } catch (error) {
        console.error("Error updating slot status:", error);
        throw error;
    }
};

const deliverySlotApi = {
    getDeliverySlots,
    addOrUpdateDeliverySlots,
    updateSlotStatus
};

export default deliverySlotApi;
